<template>
  <div class="row">
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Fecha</label>
      <VueDatePicker
        locale="es"
        cancelText="Cancelar"
        selectText="Seleccionar"
        :enable-time-picker="false"
        :format-locale="es"
        format="dd/MM/yyyy"
        v-model="fecha"
        input-class-name="dp-custom-input"
      ></VueDatePicker>
    </div>
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Fecha estimada</label>
      <VueDatePicker
        locale="es"
        cancelText="Cancelar"
        selectText="Seleccionar"
        :enable-time-picker="false"
        :format-locale="es"
        format="dd/MM/yyyy"
        v-model="fechaEstimada"
        input-class-name="dp-custom-input"
      ></VueDatePicker>
    </div>
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Importe</label>
      <input
        class="form-control"
        v-maska
        data-maska="9.99#,##"
        data-maska-tokens="9:[0-9]:repeated"
        data-maska-reversed
        inputmode="numeric"
        v-model="importe"
      />
    </div>
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Serie</label>
      <input class="form-control" v-model="serie" />
    </div>
    <div class="col-12 col-md-4 col-xl-2">
      <label class="form-label text-theme">Vendedor</label>
      <vue-select
        :options="['Vendedor 1', 'Vendedor 2', 'Vendedor 3']"
        placeholder="-- Seleciona una opción --"
        v-model="vendedorSeleccionado"
      ></vue-select>
    </div>
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Local</label>
      <vue-select
        :options="['Local 1', 'Local 2', 'Local 3']"
        placeholder="-- Seleciona una opción --"
        v-model="localSeleccionado"
      ></vue-select>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Referencia</label>
      <input class="form-control" v-model="referencia" />
    </div>
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label labelColor">Obra</label>
      <vue-select
        :options="['Obra 1', 'Obra 2', 'Obra 3']"
        placeholder="-- Seleciona una opción --"
        v-model="obraSeleccionada"
      ></vue-select>
    </div>
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Estado</label>
      <vue-select
        :options="['Estado 1', 'Estado 2', 'Estado 3']"
        placeholder="-- Seleciona una opción --"
        v-model="estadoSeleccionado"
      ></vue-select>
    </div>
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Ruta</label>
      <vue-select
        :options="['Ruta 1', 'Ruta 2', 'Ruta 3']"
        placeholder="-- Seleciona una opción --"
        v-model="rutaSeleccionada"
      ></vue-select>
    </div>
    <div class="col-12 col-md-8 col-xl-4 mb-3">
      <label class="form-label text-theme">Observaciones</label>
      <input class="form-control" v-model="observaciones" />
    </div>
  </div>
  <p class="text-end mb-0">
    <a href="javascript:;" class="btn btn-white me-5px" @click="clearForm"
      >Borrar</a
    >
    <a href="javascript:;" class="btn btn-theme">Consultar</a>
  </p>
</template>
<script setup>
import { ref } from "vue";
// datepicker
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { es } from "date-fns/locale";
// select
import vueSelect from "@/components/plugins/VueSelect.vue";
// mask para el formateo de los importes
import { Mask } from "maska";
const vMaska = Mask;
const fecha = ref();
const fechaEstimada = ref();
const importe = ref();
const serie = ref();
const vendedorSeleccionado = ref();
const localSeleccionado = ref();
const referencia = ref();
const obraSeleccionada = ref();
const estadoSeleccionado = ref();
const rutaSeleccionada = ref();
const observaciones = ref();

const clearForm = () => {
  fecha.value = null;
  fechaEstimada.value = null;
  importe.value = null;
  serie.value = null;
  vendedorSeleccionado.value = null;
  localSeleccionado.value = null;
  referencia.value = null;
  obraSeleccionada.value = null;
  estadoSeleccionado.value = null;
  rutaSeleccionada.value = null;
  observaciones.value = null;
};
</script>
<style lang="scss">
/* estilo del input del datepicker, para que sea igual al form-control */
.dp-custom-input {
  display: block;
  width: 100%;
  padding: 0.4375rem 2rem;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.5;
  color: var(--bs-component-color);
  appearance: none;
  background-color: var(--bs-component-bg);
  background-clip: padding-box;
  border: 1px solid var(--bs-component-border-color);
  border-radius: 4px;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
</style>
